import $ from "jquery";

$(function () {
    if ($(".loader-section-backdrop").length > 0) {
        addEventListener("beforeunload", (event) => {
            $(".loader-section-backdrop").removeClass("hidden");
            console.log("The page is about to change.", event);
        });
    }
});
